import { Auth0Provider } from '@auth0/auth0-react';
import { authConfig } from './config';

const AuthProvider = ({ children }: { children: React.ReactNode }) => {
    return (
        <Auth0Provider
            domain={authConfig.domain}
            clientId={authConfig.clientId}
            authorizationParams={{
                scope: authConfig.scope,
                responseType: authConfig.responseType,
                audience: authConfig.audience,
            }}
            cacheLocation="localstorage" // Keeps user logged in after refresh
            useRefreshTokens
        >
            {children}
        </Auth0Provider>
    );
};

export default AuthProvider;
